module.exports = __webpack_public_path__ + "static/media/3d-rendering-beautiful-small-bedroom-with-nice-dec-2RNRNZ5.c52b58ce.jpg";